<template>
  <div id="theme" :style="themeStyles">
    <div v-if="loading" class="flex m-auto justify-around my-24 w-full">
      <div
        class="loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-64 w-64"
      ></div>
    </div>
    <div v-if="!loading && domainInWhiteList">
      <slot></slot>
    </div>
    <div v-if="!loading && !domainInWhiteList" class="flex h-screen">
      <div class="m-auto text-gray-700 text-xl">
        Please contact support to use the MarketAnalyzer
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapGetters } = createNamespacedHelpers("whiteLabel");

export default {
  data() {
    return {
      loading: false
    };
  },
  methods: {
    ...mapActions(["setTheme"]),
    async setThemeFromApi() {
      if (this.$route.name == "home" && this.$route.query.id) {
        this.loading = true;
        await this.setTheme(this.$route.query.id);
        this.loading = false;
      }
    }
  },
  computed: {
    ...mapGetters(["primaryColor", "secondaryColor", "domainWhiteList"]),
    domainInWhiteList() {
      if (this.domainWhiteList.length) {  //Check if the agency has a domainWhiteList configured in the agency config
        return this.domainWhiteList.includes(document.referrer) //Check to see if the parent of the iframe is in the domainWhiteList array
      } else {
        return true; //Fallback to allowing the MarketAnalyzer to being shown
      }
    },
    themeStyles() {
      return {
        "--primary-color": this.primaryColor,
        "--secondary-color": this.secondaryColor
      };
    }
  },
  watch: {
    $route: "setThemeFromApi"
  }
};
</script>

<style>
.text-primary {
  color: var(--primary-color);
}
.bg-primary {
  background-color: var(--primary-color);
}
.border-primary {
  border-color: var(--primary-color);
}

.text-secondary {
  color: var(--secondary-color);
}
.bg-secondary {
  background-color: var(--secondary-color);
}
.border-secondary {
  border-color: var(--secondary-color);
}
</style>
